import MdaeFeedbackWidget from "./component";
export interface IMdaeFeedbackWidget {

  id: string;
  feedbackSectionClassName?:string;
  isMdaeFeedbackWidgetVisible:boolean
  thumbsUpClassName?: string;
  thumbsDownClassName?: string;
  onThumbsUpClick?: any;
  onThumbsDownClick?: any;
  onFeedbacklinkClick?: any;
  feedbackLinkText?: any;
  thumbsUpDisabled?:boolean;
  thumbsDownDisabled?:boolean;
  feedbackText?:string;
}
export default MdaeFeedbackWidget;
